import { render } from "./importFromExcel.vue?vue&type=template&id=267e4ba3&scoped=true"
import script from "./importFromExcel.vue?vue&type=script&lang=js"
export * from "./importFromExcel.vue?vue&type=script&lang=js"

import "./importFromExcel.vue?vue&type=style&index=0&id=267e4ba3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267e4ba3"]])

export default __exports__